import { Typography } from "@packages/ds";
import styled from "styled-components";

export const HttpAccessControlInputs = styled.div`
  margin: 0 0 24px;
  width: 100%;
  box-sizing: border-box;
  .login-list-field {
    width: 100%;
    .row {
      width: 100%;
      margin: 0 0 24px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .current-values {
        width: 264px;
      }
      &.editing {
        align-items: flex-start;
        .field {
          margin-bottom: 0;
          width: 264px;
        }
        button {
          margin-top: 26px;
        }
      }
      button {
        margin-left: 16px;
        padding-bottom: 20px;
      }
    }
  }
  .access-ips {
    display: flex;
    flex-direction: row;
    align-items: top;
    margin-bottom: 8px;
    textarea {
      min-width: 50%;
      width: auto;
    }
  }
  .row {
    line-height: 40px;
  }
  input {
    height: 40px;
    line-height: 40px;
  }
  h6 {
    margin-top: 24px;
  }
  @media (min-width: 768px) {
    margin: 0 0 24px 28px;
  }
`;

export const IpTextArea = styled.textarea`
  width: 200px;
  min-height: 50px;
  resize: none;
  font-size: 14px;
  padding: 15px;
  background-color: var(--input-ice-background-color, var(--ice));
  color: var(--input-night-color, var(--night));
  border: 1px solid var(--input-ice-border-color, var(--ice));
  &:focus {
    border: 1px solid
      var(--section-color-primary-800-border-color, var(--color-primary-800));
    box-shadow: 0 0 2px
      var(
        --section-color-primary-800-box-shadow-color,
        var(--color-primary-800)
      );
  }
`;

export const Code = styled(Typography.Code)`
  margin: unset;
`;

export const ErrorWrapper = styled.div`
  padding: 16px 0;
`;
